import {DialogContentText, DialogContent} from '@mui/material';
import React, {type FC, useCallback} from 'react';

import {useMutateDeleteUser} from '../../api/index.js';
import DeleteDialog from '../DeleteDialog.js';

interface MonitorDeleteProps {
  open: boolean;
  onClose: () => void;
  id: string;
  name: string;
  onSubmit: () => void;
}

const MonitorDelete: FC<MonitorDeleteProps> = ({open, onClose, id, name, onSubmit: onSubmitProp}) => {
  const deleteMutation = useMutateDeleteUser();

  const onSubmit = useCallback(async () => {
    await deleteMutation.mutateAsync(id);
    onSubmitProp();
  }, [id, deleteMutation, onSubmitProp]);

  return (
    <DeleteDialog
      open={open}
      name={'monitor'}
      onClose={onClose}
      onSubmit={onSubmit}
    >
      <DialogContent>
        <DialogContentText id={'monitor-alert-dialog-description'}>
          {name}
        </DialogContentText>
      </DialogContent>
    </DeleteDialog>
  );
};

export default MonitorDelete;
